export const searchForTags = async (tags, searcher) => {
    let tagsToSearch = tags.slice(0, tags.length - 1);
    let tagToSearch = tags[tags.length - 1];
    searcher.selectedTags = tagsToSearch;
    let tagsFound = await searcher.getTopTags();
    searcher.selectedTags = [];
    
    tagsFound = tagsFound
        .map(x => x.value)
        .filter(x => x
                .toLowerCase()
                .includes(tagToSearch.toLowerCase()));
    return getSuggestions(tagsFound, tagsToSearch);
}
    
const getSuggestions = (tagsFound, tagsToSearch) => {
    if (tagsFound.length === 1) {
        return {
            tags: [... tagsToSearch, tagsFound[0]],
            suggestions: [],
        };
    }
    
    let suggestions =  tagsFound;
    
    if (tagsToSearch === '') {
        return {
            suggestions
        };
    }
    let longestPrefix = getLongestCommonPrefix(tagsFound);
    if (longestPrefix) {
        return {
            suggestions,
            tags: [... tagsToSearch, longestPrefix]
        };
    }
    return {
        suggestions,
        tags: [],
    };
}


export const getLongestCommonPrefix = (tags) => {
    let longestPrefix = undefined;
    for (let i in tags) {
        if (longestPrefix === undefined) {
            longestPrefix = tags[i];
        } else {
            longestPrefix = getCommonPrefix(tags[i], longestPrefix);
            if (longestPrefix === undefined) {
                return undefined;
            }
        }
    }
    
    return longestPrefix;
}

const getCommonPrefix = (a, b) => {
    let prefix = '';
    for (let i=0; i < Math.min(a.length, b.length); i++) {
        if (a[i] === b[i]) {
            prefix += a[i];
        } else {
            break;
        }
    }
    
    return prefix === '' ? undefined : prefix;
};
